import { render, staticRenderFns } from "./BrandSlider.vue?vue&type=template&id=26697e31"
import script from "./BrandSlider.vue?vue&type=script&lang=js"
export * from "./BrandSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports